(()=>{
  'use strict';
  const config=document.querySelector('[data-review-analytics]');
  if(!config)return;
  const id=config.dataset.measurementId;
  const live=window.Shopify?.theme?.role==='main'&&!window.Shopify?.designMode;
  const privacyReady=new Promise(resolve=>{
    if(window.Shopify?.customerPrivacy){resolve(true);return}
    if(typeof window.Shopify?.loadFeatures==='function')window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>resolve(!error));
    else resolve(false);
  });
  const storage={get:k=>{try{return JSON.parse(sessionStorage.getItem(k)||'null')}catch{return null}},set:(k,v)=>{try{sessionStorage.setItem(k,JSON.stringify(v))}catch{}}};
  async function emit(name,params={}){
    if(!live||!id)return;
    if(!await privacyReady||!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.())return;
    window.dataLayer=window.dataLayer||[];
    window.gtag=window.gtag||function(){window.dataLayer.push(arguments)};
    if(!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')&&!window.__reviewGtagLoaded){
      window.__reviewGtagLoaded=true;const script=document.createElement('script');script.async=true;script.src='https://www.googletagmanager.com/gtag/js?id='+encodeURIComponent(id);document.head.append(script);window.gtag('js',new Date());window.gtag('config',id,{send_page_view:false});
    }
    window.gtag('event',name,{send_to:id,...params});
  }
  if(document.querySelector('main')){
    document.querySelectorAll('main a[href]').forEach(a=>{
      if(/\/pages\/contact(?:[?#]|$)/.test(a.getAttribute('href'))&&/trial|prób|essai/i.test(a.textContent)){
        const lang=location.pathname.match(/^\/(pl|fr)(?:\/|$)/)?.[0].replace(/\/$/,'')||'';a.href=lang+'/pages/english-trial-lesson#MfcVisitForm';
      }
    });
  }
  if(!live){
    document.querySelectorAll('a[href*="/pages/assessment-centre"],a[href*="/pages/english-trial-lesson"]').forEach(a=>{
      const u=new URL(a.href,location.origin);if(u.origin!==location.origin)return;
      const type=u.pathname.endsWith('/pages/assessment-centre')?'assessment-centre':'english-trial';
      u.pathname=u.pathname.replace(/\/pages\/(assessment-centre|english-trial-lesson)$/,'/pages/contact');u.searchParams.set('view',type);a.href=u.href;
    });
  }
  document.querySelectorAll('form[data-review-form]').forEach(form=>{
    const key='review.pending.'+form.id;
    form.addEventListener('focusin',()=>{if(!form.dataset.started){form.dataset.started='true';emit('lead_form_start',{form_id:form.id,lead_type:form.dataset.reviewForm})}},{once:true});
    form.addEventListener('submit',()=>{
      if(form.checkValidity())storage.set(key,{nonce:window.crypto?.randomUUID?.()||String(Date.now()),type:form.dataset.reviewForm});
    });
    const success=form.querySelector('[data-review-success]');
    if(success){const pending=storage.get(key);if(pending&&!storage.get('review.sent.'+pending.nonce)){emit('generate_lead',{form_id:form.id,lead_type:pending.type});storage.set('review.sent.'+pending.nonce,true);storage.set(key,null)}success.focus()}
  });
  document.querySelectorAll('input[data-weekdays-only]').forEach(input=>{
    const today=new Date();today.setHours(0,0,0,0);input.min=[today.getFullYear(),String(today.getMonth()+1).padStart(2,'0'),String(today.getDate()).padStart(2,'0')].join('-');
    input.addEventListener('change',()=>{input.setCustomValidity('');if(input.value){const chosen=new Date(input.value+'T12:00:00');if(chosen.getDay()===0||chosen.getDay()===6)input.setCustomValidity(input.dataset.weekdayError);else if(input.value<input.min)input.setCustomValidity(input.dataset.pastError)}});
  });
  document.addEventListener('click',event=>{const a=event.target.closest('a[href]');if(!a)return;const h=a.getAttribute('href');if(/^https:\/\/wa.me\//.test(h))emit('whatsapp_click',{page_type:'school'});else if(/^tel:/.test(h))emit('phone_click',{page_type:'school'});else if(/^mailto:/.test(h))emit('email_click',{page_type:'school'})});
})();
